/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![IdIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABC0lEQVR4nGNgGDYgNDSUzS8gvNPXP/yZX0DEf3Kwb0D4U7+AiA6QWRgWgCTINdgPE3dgWECJy/3QsX/Ec2w++E9NzDDwFgSGh4JxQMQPFD4Yh0X4+UUU+vmH7yLbAiTxr1g1wOIuICLM1z/iD9Us8A2IOOTnH37MLyB8UmhoqBA0gUykpgWf4OneP2IJWI1fhCFtLAgIfwoS8/DwYKeVBe9BYqGhocx+ARH/aGHBCZCYj0+oHA18EP7C3z/cFiIWnkk1C/z9wxVALgYFCzSCpbAVM2RbAAL19fVMgYHRMv7+kSl+ARFPBmlREUBlC3whlQW1LHhC0wrH1z+iHUeVGdFBiU988VWZQxYAAFoklIOxHTNUAAAAAElFTkSuQmCC)
 */
export const IdIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.3 14.48c-.46.45-1.08.67-1.86.67h-1.39V9.2h1.39c.78 0 1.4.22 1.86.67.46.45.68 1.22.68 2.31 0 1.1-.22 1.86-.68 2.31Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm1 15h2.04V7.34H6V17Zm4-9.66V17h3.44c1.46 0 2.6-.42 3.38-1.25.8-.83 1.2-2.02 1.2-3.58s-.4-2.75-1.2-3.58c-.79-.83-1.92-1.25-3.38-1.25H10Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
